export const LegalSection = ({ heading, children }) => (
  <section className="mt-10">
    <h2 className="text-xl font-bold text-[#0B1F33] md:text-2xl">{heading}</h2>
    <div className="mt-3 space-y-4 text-base leading-relaxed text-[#263238]">{children}</div>
  </section>
);

export const LegalBody = ({ children, testId }) => (
  <div className="bg-white py-16 lg:py-20">
    <div className="mx-auto max-w-3xl px-5 lg:px-8" data-testid={testId}>
      {children}
    </div>
  </div>
);
